module.exports = __webpack_public_path__ + "img/right_select.afeb8aeb.png";